/* eslint-disable */
import Header from "components/Common/Header/Header";
import CustomerPriceListBody from "components/MarketplaceComponents/CustomerPriceList/CustomerPriceListBody";
import { useEffect } from "react";

const CustomerPriceList = () => {
  useEffect(() => {
    document.title = "Marketplace";
  }, []);

  return (
    <main id="app">
      {/* ---- common header ---- */}
      <Header moduleName="marketplace" />

      <CustomerPriceListBody />
    </main>
  );
};

export default CustomerPriceList;
